module.exports = __webpack_public_path__ + "img/gold_symbol_4.5d90fa68.png";